import { App } from '@capacitor/app'
import { isNativePlatform, platformName } from '@/platform/platform'
import { updateManager } from '@/platform/update-manager'
import { getActiveIdentity } from '@/services/identity/local-identity'

export const API_VERSION = 'v1'

let nativeVersion: string | null = null
let webBundleVersion: string | null = null

async function resolveNativeVersion() {
  if (!isNativePlatform()) return ''
  if (nativeVersion === null) {
    try {
      nativeVersion = (await App.getInfo()).version
    } catch {
      nativeVersion = ''
    }
  }
  return nativeVersion
}

async function resolveWebVersion() {
  if (webBundleVersion === null) {
    if (isNativePlatform()) {
      try {
        webBundleVersion = (await updateManager.getStatus())?.currentVersion || __APP_WEB_VERSION__
      } catch {
        webBundleVersion = __APP_WEB_VERSION__
      }
    } else {
      webBundleVersion = __APP_WEB_VERSION__
    }
  }
  return webBundleVersion
}

// Version headers let the server correlate requests from mixed native shells
// and OTA web bundles without forking the API.
export async function buildAppHeaders(): Promise<Record<string, string>> {
  const [native, web, identity] = await Promise.all([
    resolveNativeVersion(),
    resolveWebVersion(),
    getActiveIdentity().catch(() => null),
  ])
  const headers: Record<string, string> = {
    'X-App-Platform': platformName(),
    'X-App-Web-Version': web,
    'X-API-Version': API_VERSION,
  }
  if (native) headers['X-App-Native-Version'] = native
  if (identity?.deviceId) headers['X-App-Device-Id'] = identity.deviceId
  return headers
}
